var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"mobile_locations_widget"}},[_c('title-bar',{attrs:{"leftButton":this.titleBar.left,"rightButton":this.titleBar.right,"title":this.titleBar.title}}),_c('router-view',{ref:"view"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }